export class BlEventName {
    static readonly FmsTracker: string = "bl_tracker";
    static readonly FmsHawbRcvd: string = "bl_hawb_rcvd";
    static readonly FmsLastTrack: string = "bl_last_track";
    static readonly FmsPlRcvd: string = "bl_pl_rcvd";
    static readonly FmsAnPrt: string = "bl_an_prt";
    static readonly FmsCommDoc: string = "bl_comm_doc";
    static readonly FmsEntryDoc: string = "bl_entry_doc";
    static readonly Fms7501: string = "bl_7501";
    static readonly FmsEtaCfrmd: string = "bl_eta_cfrmd";
    static readonly Fms3461: string = "bl_3461";
    static readonly FmsAmsCfrmd: string = "bl_ams_cfrmd";
    static readonly FmsInlandNtc: string = "bl_inland_ntc";
    static readonly FmsPuSent: string = "bl_pu_sent";
    static readonly FmsExamOn: string = "bl_exam_on";
    static readonly FmsExamOff: string = "bl_exam_off";
    static readonly FmsDoConfirm: string = "bl_do_confirm";
    static readonly FmsDoSent: string = "bl_do_sent";
    static readonly FmsDelAddr: string = "bl_del_addr";
    static readonly FmsDelSched: string = "bl_del_sched";
    static readonly FmsDelAct: string = "bl_del_act";
    static readonly FmsEmptyRet: string = "bl_empty_ret";
    static readonly FmsPod: string = "bl_pod";
    static readonly FmsBill: string = "bl_bill";
    static readonly FmsBillPacket: string = "bl_bill_packet";
    static readonly FmsDdp: string = "bl_ddp";
}